const leafMass100m = computeLeafMass(100.0);
const woodMass100m = computeWoodMass(100.0);
const rootMass100m = computeRootMass(100.0);

export function computeLeafMass(area) {
  let result = 0;
  if (area > 200.0) {
    const areaDivisor = 100.0;
    const treeCount100m = Math.floor(area / areaDivisor);
    const treeLessThan100mArea = area - treeCount100m * areaDivisor;
    result = leafMass100m * treeCount100m;
    result += computeLeafMass(treeLessThan100mArea);
  } else {
    result = 0.2693 * Math.pow(area, 0.9441);
  }
  return result;
}

export function computeWoodMass(area) {
  let result = 0;
  if (area > 200.0) {
    const areaDivisor = 100.0;
    const treeCount100m = Math.floor(area / areaDivisor);
    const treeLessThan100mArea = area - treeCount100m * areaDivisor;
    result = woodMass100m * treeCount100m;
    result += computeWoodMass(treeLessThan100mArea);
  } else {
    result = 3.9448 * Math.pow(area, 1.1068);
  }
  return result;
}

export function computeRootMass(area) {
  let result = 0;
  if (area > 200.0) {
    const areaDivisor = 100.0;
    const treeCount100m = Math.floor(area / areaDivisor);
    const treeLessThan100mArea = area - treeCount100m * areaDivisor;

    result = rootMass100m * treeCount100m;
    result += computeRootMass(treeLessThan100mArea);
  } else {
    result = 0.8339 * Math.pow(area, 1.173);
  }
  return result;
}

// These calcs converted from Jesse Meyer's C code using ChatGPT(!). Jesse's email follows:
// So, we’re updating carbon values for all of the tree polygons.  The update logic is simple, but I don’t know if us resending to you the entire bulk package (with only those attributes updates applied, seems wasteful), or if the means for you to make the change locally is preferrable?

// The leaf, wood, and mass equations are as follows (as written in C, should translate nearly verbatim to JavaScript)

// inline internal r32

// compute_leaf_mass(r32 area) {

//     r32 result = 0.2693 * pow(area, 0.9441);

//     return result;

// }

// inline internal r32

// compute_wood_mass(r32 area) {

//     r32 result = 3.9448 * pow(area, 1.1068);

//     return result;

// }

// inline internal r32

// compute_root_mass(r32 area) {

//     r32 result = 0.8339 * pow(area, 1.1730);

//     return result;

// }

// The per tree mass determination logic (where ‘area’ refers to the attribute field area instead of the feature geometry’s area):

//         r32 leaf_mass = 0.0;

//         r32 wood_mass = 0.0;

//         r32 root_mass = 0.0;

//         if (area > 200.0) { //NOTE(Jesse): Pierre had me raise 150.0 to 200.0

//             r32 area_divisor = 100.0; //NOTE(Jesse): Pierre had me raise 75.0 to 100.0

//             u32 tree_count_100m = area / area_divisor; //IMPORTANT(Jesse): This produces an integer!!!

//             r32 tree_lt_100m_area = area - (tree_count_100m * area_divisor);

//             leaf_mass = leaf_mass_100m * tree_count_100m;

//             leaf_mass += compute_leaf_mass(tree_lt_100m_area);

//             wood_mass = wood_mass_100m * tree_count_100m;

//             wood_mass += compute_wood_mass(tree_lt_100m_area);

//             root_mass = root_mass_100m * tree_count_100m;

//             root_mass += compute_root_mass(tree_lt_100m_area);

//         }

//         else {

//             leaf_mass = compute_leaf_mass(area);

//             wood_mass = compute_wood_mass(area);

//             root_mass = compute_root_mass(area);

//         }

// Where leaf|wood|root_mass_100m is precalculated as an optimization:

//     r32 leaf_mass_100m = compute_leaf_mass(100.0);

//     r32 wood_mass_100m = compute_wood_mass(100.0);

//     r32 root_mass_100m = compute_root_mass(100.0);

// leaf|wood|root_mass are then summed to produce a total mass, and multiplied by 0.47 to convert to carbon.
